import { useLocation } from 'react-router';

import AuthLayout from '@/components/AuthLayout';
import ResetPasswordForm from '@/components/ResetPasswordForm';
import ChangePasswordForm from '@/components/ChangePasswordForm';


const ChangePasswordPage = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const email = searchParams.get('email');
  const userName = searchParams.get('username');
  const prefill = searchParams.get('prefill');

  return (
    <AuthLayout>
      {token ? <ChangePasswordForm token={token} userIdentification={email || userName} /> : <ResetPasswordForm prefillIdentification={prefill} />}
    </AuthLayout>
  );
};

export default ChangePasswordPage;
